export default __webpack_public_path__ + "81cf4e2fb41e2ad758e307e9648d5a38.png";